// @flow
import {
    FORM_EMAIL_SETTING,
    FORM_EMAIL_SETTING_SUCCESS,
    FORM_EMAIL_SETTING_FAILED,
    FORM_EMAIL_SETTING_SAVE
} from '../../../constants/actionTypes';

const INIT_STATE = {
    loading: false,
    emailsetting: null
};

type FormAction = { type: string, payload: {} | string };
type State = { loading?: boolean, +value?: boolean, emailsetting?: {} | null, saving?: boolean};

const FormEmailSetting = (state:State = INIT_STATE, action: FormAction) => {
    switch (action.type) {
        case FORM_EMAIL_SETTING:
            return { ...state, loading: true };
        case FORM_EMAIL_SETTING_SAVE:
            return { ...state, saving: true };
        case FORM_EMAIL_SETTING_SUCCESS:
            return { ...state, emailsetting: action.payload, loading: false, saving: false, error: null };
        case FORM_EMAIL_SETTING_FAILED:
            return { ...state, error: action.payload, loading: false, saveing: false };
        default: return { ...state };
    }
}

export default FormEmailSetting;